<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div class="bg-white rounded-lg p-6 mb-4">
      <h2 class="font-bold text-xl mb-4">Accounthilfe</h2>

      <div class="mb-6">
        <h3 class="font-bold text-lg mb-2">Account aktivieren / Passwort zurücksetzen</h3>
        <label>Mailadresse auswählen</label>
        <select v-model="selectedMail" class="border-2 border-gray-200 px-2 py-1 w-full max-w-md">
          <option value="">Mailadresse auswählen</option>
          <option v-for="cred in credentials" :key="cred.id" :value="cred.mail">{{ cred.mail }}</option>
        </select>
        <div class="mt-4 flex gap-4" v-if="selectedMail">
          <button @click="activateAccount">Account aktivieren</button>
          <button @click="resetPassword" class="bg-yellow-500">Passwort zurücksetzen</button>
        </div>
        <div v-if="activateMsg" class="mt-4" :class="activateSuccess ? 'text-green-600' : 'text-red-600'">{{ activateMsg }}</div>
        <div v-if="newPassword" class="mt-2 p-2 bg-yellow-100 rounded">
          Neues Passwort: <strong>{{ newPassword }}</strong>
        </div>
      </div>

      <div class="border-t pt-6">
        <h3 class="font-bold text-lg mb-2">Verträge übertragen (Accounts zusammenführen)</h3>
        <div class="grid grid-cols-2 gap-4 max-w-2xl">
          <div>
            <label>Alter Account</label>
            <input type="text" v-model="oldSearch" @input="searchOld" placeholder="Name oder E-Mail suchen..." class="border-2 border-gray-200 px-2 py-1 w-full mb-2">
            <select v-if="oldResults.length > 0" v-model="oldAccountId" class="border-2 border-gray-200 px-2 py-1 w-full">
              <option value="">Kunde auswählen</option>
              <option v-for="c in oldResults" :key="c.id" :value="c.id">{{ c.NachnameErziehungsberechtigter }}, {{ c.VornameErziehungsberechtigter }} ({{ c.EmailEltern }})</option>
            </select>
          </div>
          <div>
            <label>Ziel-Account</label>
            <input type="text" v-model="currentSearch" @input="searchCurrent" placeholder="Name oder E-Mail suchen..." class="border-2 border-gray-200 px-2 py-1 w-full mb-2">
            <select v-if="currentResults.length > 0" v-model="currentAccountId" class="border-2 border-gray-200 px-2 py-1 w-full">
              <option value="">Kunde auswählen</option>
              <option v-for="c in currentResults" :key="c.id" :value="c.id">{{ c.NachnameErziehungsberechtigter }}, {{ c.VornameErziehungsberechtigter }} ({{ c.EmailEltern }})</option>
            </select>
          </div>
        </div>
        <div class="mt-4" v-if="oldAccountId && currentAccountId">
          <button @click="mergeAccounts" class="bg-red-500 text-white">Verträge übertragen</button>
        </div>
        <div v-if="mergeMsg" class="mt-4" :class="mergeSuccess ? 'text-green-600' : 'text-red-600'">{{ mergeMsg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "AccountHelp",
  props: ["user"],
  data() {
    return {
      credentials: [],
      selectedMail: "",
      newPassword: null,
      activateMsg: null,
      activateSuccess: false,
      oldAccountId: "",
      currentAccountId: "",
      oldSearch: "",
      currentSearch: "",
      oldResults: [],
      currentResults: [],
      mergeMsg: null,
      mergeSuccess: false,
    };
  },
  methods: {
    loadCredentials() {
      API.getCredentialsList((r) => { this.credentials = r; });
    },
    searchOld() {
      if (this.oldSearch.length < 2) { this.oldResults = []; return; }
      API.searchCustomers(this.oldSearch, (r) => { this.oldResults = r; });
    },
    searchCurrent() {
      if (this.currentSearch.length < 2) { this.currentResults = []; return; }
      API.searchCustomers(this.currentSearch, (r) => { this.currentResults = r; });
    },
    activateAccount() {
      API.activateAccount(this.selectedMail, (r, status) => {
        if (status === 200) {
          this.activateSuccess = true;
          this.activateMsg = "Der Kundenaccount wurde erfolgreich aktiviert.";
        } else {
          this.activateSuccess = false;
          this.activateMsg = "Dieser Nutzer hat sich noch nicht registriert.";
        }
        this.newPassword = null;
      });
    },
    resetPassword() {
      API.resetPassword(this.selectedMail, (r, status) => {
        if (status === 200) {
          this.activateSuccess = true;
          this.activateMsg = "Das Passwort wurde zurückgesetzt.";
          this.newPassword = r.message.replace("Das neue Passwort lautet: ", "");
        } else {
          this.activateSuccess = false;
          this.activateMsg = "Dieser Nutzer hat sich noch nicht registriert.";
          this.newPassword = null;
        }
      });
    },
    mergeAccounts() {
      if (!confirm("Wirklich alle Verträge übertragen und den alten Account löschen?")) return;
      API.mergeAccounts(this.oldAccountId, this.currentAccountId, (r, status) => {
        if (status === 200) {
          this.mergeSuccess = true;
          this.mergeMsg = r.message;
          this.oldAccountId = "";
          this.currentAccountId = "";
          this.oldSearch = "";
          this.currentSearch = "";
          this.oldResults = [];
          this.currentResults = [];
        } else {
          this.mergeSuccess = false;
          this.mergeMsg = r.message || "Fehler beim Zusammenführen.";
        }
      });
    },
  },
  created() {
    this.loadCredentials();
  },
};
</script>

<style scoped>
label { display: block; font-weight: bold; margin-bottom: 4px; }
</style>
